<!--
 * @Description: 编辑代理商户
 * @Author: gao shuai
 * @Date: 2020-04-23 21:49:06
 * @LastEditTime: 2020-09-26 17:05:19
 * @LastEditors: gao shuai
 -->

<template>
  <div>
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>编辑商户</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <p>
      <el-button size="small" type="primary" icon="el-icon-back" @click="backpage">返回上一级</el-button>
    </p>
    <div class="bg_fff mgt10">
      <div class="gs_title">银行信息</div>
      <div class="gs_tablebox">
        <el-table ref="moduleTable" size="mini" :data="bankinfo.tableData" border style="width: 100%" stripe>
          <el-table-column prop="realName" label="帐户名" width="120">
          </el-table-column>
          <el-table-column prop="bankName" label="开户银行" width="120">
          </el-table-column>
          <el-table-column prop="bankBranch" label="开户地区">
          </el-table-column>
          <el-table-column prop="bankNumber" label="银行卡号">
          </el-table-column>
          <el-table-column label="帐户余额">
            <template slot-scope="scope">
              <span>{{ scope.row.overMoney.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="总存入">
            <template slot-scope="scope">
              <span>{{ scope.row.allDeposit.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="总支出">
            <template slot-scope="scope">
              <span>{{ scope.row.allPay.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" type="info" @click="editclick(scope.row)">编辑</el-button>
              <el-button v-if="scope.row.activated" size="mini" type="danger"
                @click.prevent="freeze(scope.row.id, scope.row.activated)">冻结帐户</el-button>
              <el-button v-else size="mini" type="primary"
                @click.prevent="freeze(scope.row.id, scope.row.activated)">解冻帐户</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="bg_fff mgt10">
      <div class="gs_title">
        基本信息
        <span class="fr mgr10">
          <el-button size="mini" type="info" @click.prevent="resetting">重置密码</el-button>
          <el-button size="mini" type="warning" @click.prevent="resetTip">重置二级密码</el-button>
        </span>
      </div>
      <div class="gs_tablestyle">
        <table>
          <tbody>
            <tr>
              <!-- <td class="tit">用户名：</td>
              <td>
                <el-input size="small" v-model="basedata.username" placeholder="请输入内容"></el-input>
              </td> -->
              <td class="tit">商户账号：</td>
              <td>
                <el-input size="small" v-model="basedata.merchantAccount" placeholder="请输入内容"></el-input>
              </td>
              <td class="tit">注册时间：</td>
              <td>
                <el-input size="small" v-model="basedata.joindate" disabled></el-input>
              </td>
              <td class="tit">比率组：</td>
              <td>
                <el-select v-model="basedata.ratiogroup" size="small" placeholder="请选择">
                  <el-option v-for="(item, i) in ratiogroupdrow" :key="'ratiogroup' + i" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="tit">代理ID：</td>
              <td>
                <el-input size="small" v-model="basedata.actingparentID" @input="
                  basedata.actingparentID = intNumber(basedata.actingparentID)
                  " placeholder="请输入内容"></el-input>
              </td>
              <td class="tit">商户类型：</td>
              <td>
                <el-select v-model="basedata.typemerchant" size="small" placeholder="请选择">
                  <el-option v-for="(item, i) in typemerchantdrow" :key="'typemerchant' + i" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </td>
              <td class="tit">客服电话：</td>
              <td>
                <el-input size="small" v-model="basedata.cSTelephone" @input="
                  basedata.cSTelephone = intNumber(basedata.cSTelephone)
                  " placeholder="请输入内容"></el-input>
              </td>
              <!-- <td class="tit">网站名：</td>
              <td>
                <el-input size="small" v-model="basedata.websiteName" placeholder="请输入内容"></el-input>
              </td> -->
            </tr>
            <tr>
              <!-- <td class="tit">网站域名：</td>
              <td>
                <el-input size="small" v-model="basedata.webdomainname" placeholder="请输入内容"></el-input>
              </td> -->

              <td class="tit">商户ＱＱ：</td>
              <td>
                <el-input size="small" v-model="basedata.businessQQ"
                  @input="basedata.businessQQ = intNumber(basedata.businessQQ)" placeholder="请输入内容"></el-input>
              </td>
              <td class="tit">提现手续费：</td>
              <td>
                <el-input size="small" v-model="basedata.cashcharge"
                  @input="basedata.cashcharge = intNumber(basedata.cashcharge)" placeholder="请输入内容"></el-input>
              </td>
              <td class="tit">客服ＱＱ：</td>
              <td>
                <!-- <el-input size="small" v-model="basedata.customerQQ" @input="basedata.customerQQ=intNumber(basedata.customerQQ)" placeholder="请输入内容"></el-input> -->
                <!-- <span class="mgr10 qqspan" v-for="(item,i) in basedata.customerQQ" :key="'qq'+i">{{item.name+' : '+item.qq}}</span> -->
                <el-tooltip v-for="(item, i) in basedata.customerQQ" :key="'qq' + i" class="popitem" effect="dark"
                  content="单击可编辑" placement="bottom">
                  <el-tag class="mgr10 mgb5" closable @click="editqq(item, i)" @close="delQQ(i)">
                    {{ item.name + " : " + item.qq }}
                  </el-tag>
                </el-tooltip>
                <el-button size="mini" type="primary" @click="dialogqq.show = true">新增</el-button>
              </td>
            </tr>
            <tr>
              <td class="tit">结算类型：</td>
              <td>
                <el-select v-model="basedata.typesettlement" size="small" placeholder="请选择">
                  <el-option v-for="(item, i) in typesettlementdrow" :key="'typesettlement' + i" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </td>
              <td class="tit">发布站来源统计：</td>
              <td>
                <el-select v-model="basedata.pstatistics" size="small" placeholder="请选择">
                  <el-option v-for="(item, i) in pstatisticsdrow" :key="'pstatistics' + i" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </td>
              <td class="tit">客服状态：</td>
              <td>
                <el-select v-model="basedata.cservicestatus" size="small" placeholder="请选择">
                  <el-option v-for="(item, i) in cservicestatusdrow" :key="'cservicestatus' + i" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="tit">商户状态：</td>
              <td>
                <el-select v-model="basedata.businessstatus" size="small" placeholder="请选择">
                  <el-option v-for="(item, i) in businessstatusdrow" :key="'businessstatus' + i" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </td>
              <td class="tit">登陆器访问统计：</td>
              <td>
                <el-select v-model="basedata.Lstatistics" size="small" placeholder="请选择">
                  <el-option v-for="(item, i) in Lstatisticsdrow" :key="'Lstatistics' + i" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </td>
              <td class="tit">留言功能：</td>
              <td>
                <el-select v-model="basedata.messagefunction" size="small" placeholder="请选择">
                  <el-option v-for="(item, i) in messagefunctiondrow" :key="'messagefunction' + i" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="tit">联系电话：</td>
              <td>
                <el-input size="small" v-model="basedata.contactComputer" @input="
                  basedata.contactComputer = intNumber(
                    basedata.contactComputer
                  )
                  " placeholder="请输入内容"></el-input>
              </td>
              <td class="tit">商户唯一标识：</td>
              <td>
                <span>{{ basedata.merchantmark }}</span>
              </td>
              <td class="tit">商户密钥：</td>
              <td>
                <span>{{ basedata.merchantkey }}</span>
              </td>
            </tr>
            <tr>
              <td class="tit">是否开启随机金额：</td>
              <td>
                <el-radio-group v-model="basedata.isOpenRandomMoney">
                  <el-radio :label="true">开启</el-radio>
                  <el-radio :label="false">不开启</el-radio>
                </el-radio-group>
              </td>
              <td class="tit">电子签合同是否完成：</td>
              <td>
                <el-radio-group v-model="basedata.isSigned">
                  <el-radio :label="true">已完成</el-radio>
                  <el-radio :label="false">未完成</el-radio>
                </el-radio-group>
              </td>
            </tr>
            <tr>
              <td class="tit">微信服务：</td>
              <!-- <td colspan="5"> -->
              <td>
                <span v-if="basedata.wxserver.length > 0" style="color: red">
                  <!-- <i style="cursor:pointer;margin-right:10px;margin-left:10px;" @click="unbindWeixin">点击解绑</i>
                  <i style="color:green">(已绑定)</i> -->
                  <el-checkbox :indeterminate="basedata.weixin.isIndeterminate" v-model="basedata.weixin.checkAll"
                    @change="handleCheckAllChange">全选</el-checkbox>
                  <i style="
                      cursor: pointer;
                      margin-right: 10px;
                      margin-left: 20px;
                      color: green;
                      font-size: 14px;
                    " @click="unbindWeixin">点击解绑</i>
                  <div style="margin-top: 8px"></div>
                  <el-checkbox-group v-model="basedata.weixin.checkedCities" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="(item, i) in basedata.wxserver" :label="item" :key="'key' + i">{{ item.nickname
                      }}</el-checkbox>
                  </el-checkbox-group>
                </span>
                <span v-else style="color: red">商户暂未绑定微信服务</span>
              </td>
              <td class="tit">添加用户专属产品：</td>
              <td>

                <el-button size="mini" type="primary" @click="showUserProduct = true">修改</el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <p class="tc pdt10 pdb10">
      <el-button type="primary" @click="merchantupdate">提交</el-button>
    </p>
    <!-- 编辑产品的弹框 -->
    <el-dialog title="编辑帐户" :visible.sync="bankinfo.show" @close="dialoginit" custom-class="gs_dialog" width="570px">
      <div class="opeartbox">
        <ul class="clearfix">
          <li>
            <span class="tit">账户名</span>
            <span class="txtbox">
              <el-input size="small" v-model="bankinfo.accountname"></el-input>
            </span>
          </li>
          <li>
            <span class="tit">身份证号</span>
            <span class="txtbox">
              <el-input size="small" v-model="bankinfo.idNumber"></el-input>
            </span>
          </li>
          <li>
            <span class="tit">开户银行</span>
            <span class="txtbox">
              <el-select style="width: 400px" v-model="bankinfo.bankdeposit" size="small" placeholder="请选择">
                <el-option v-for="(item, i) in bankinfo.bankdepositdrow" :key="'bankdeposit' + i" :label="item.bankName"
                  :value="item.bankName"></el-option>
              </el-select>
            </span>
          </li>
          <li>
            <span class="tit">开户支行</span>
            <span class="txtbox">
              <el-input size="small" v-model="bankinfo.bankopeningbranch"></el-input>
            </span>
          </li>
          <li>
            <span class="tit">账户卡号</span>
            <span class="txtbox">
              <el-input size="small" v-model="bankinfo.accountnumber"></el-input>
            </span>
          </li>
        </ul>
      </div>
      <p class="tc pdt10 pdb10">
        <el-button size="small" type="primary" @click="bankupdate">提交</el-button>
      </p>
    </el-dialog>
    <!-- 添加客服QQ -->
    <el-dialog :title="dialogqq.editflag ? '编辑客服QQ' : '添加客服QQ'" :visible.sync="dialogqq.show" @close="dialogqqinit"
      custom-class="gs_dialog" width="420px">
      <div class="editserverBox">
        <div class="list clearfix">
          <span class="tit">客服名称：</span>
          <div class="content">
            <el-input size="small" v-model="dialogqq.name" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="list clearfix">
          <span class="tit">QQ号码：</span>
          <div class="content">
            <el-input size="small" v-model="dialogqq.qq" @input="dialogqq.qq = intNumber(dialogqq.qq)"
              placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <p class="tc pdb10">
        <el-button v-if="dialogqq.editflag" size="small" type="primary" @click="editserver">确定</el-button>
        <el-button v-else size="small" type="primary" @click="addserver">确定</el-button>
        <el-button size="small" type="info" @click="dialogqq.show = false">取消</el-button>
      </p>
    </el-dialog>


    <!-- 编辑用户专属产品的弹框 -->
    <el-dialog title="用户专属产品" :visible.sync="showUserProduct" @close="dialoginit" custom-class="gs_dialog"
      width="550px">
      <el-table :data="userProducts" style="width: 100%">
        <el-table-column prop="checked" label="是否选中" width="180">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.checked" active-color="#13ce66" inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="productId" label="产品Id" width="180">
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" width="180">
        </el-table-column>

      </el-table>
      <p class="tc pdt10 pdb10">
        <el-button size="small" type="primary" @click="userProductUpdate">提交</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dataId: Number,
    fee: Number,
  },
  data() {
    return {
      basedata: {
        id: "", // id
        username: "", // 用户名
        merchantAccount: "", // 商户账号
        joindate: "", // 注册时间
        ratiogroup: "", // 比率组
        actingparentID: "", // 代理ID
        typemerchant: "", // 商户类型
        websiteName: "", // 网站名
        webdomainname: "", // 网站域名
        cSTelephone: "", // 客服电话
        businessQQ: "", // 商户ＱＱ
        cashcharge: 0, // 提现手续费：
        customerQQ: [], // 客服ＱＱ
        typesettlement: "", // 结算类型
        pstatistics: "", // 发布站来源统计
        cservicestatus: "", // 客服状态
        businessstatus: "", // 商户状态
        Lstatistics: "", // 登陆器访问统计
        messagefunction: "", // 留言功能
        contactComputer: "", // 联系电话
        merchantmark: "", // 商户唯一标识
        merchantkey: "", // 商户密钥
        isOpenRandomMoney: true,
        wxserver: [], // 微信服务
        weixin: {
          checkAll: false,
          checkedCities: [],
          isIndeterminate: true,
        },
        realName: "",
        idNumber: "",
        isSigned: false
      },
      bankinfo: {
        show: false, // 编辑的弹框显隐
        bankdepositdrow: [], // 开户银行下拉
        id: "", // id号
        accountname: "", // 账户名
        bankdeposit: "", // 开户银行
        bankopeningbranch: "", // 开户支行
        accountnumber: "", // 账户卡号
        tableData: [],
        idNumber: ''
      },
      bankcard: false,
      ratiogroupdrow: [], // 比率组下拉
      userProducts: [], // 用户产品列表
      showUserProduct: false,
      typemerchantdrow: [
        { text: "普通商户", value: false },
        { text: "代理商户", value: true },
      ], // 商户类型下拉
      typesettlementdrow: [
        { text: "T+0", value: 0 },
        { text: "T+1", value: 1 },
      ], // 结算类型下拉
      pstatisticsdrow: [
        { text: "开启", value: true },
        { text: "关闭", value: false },
      ], // 发布站来源统计下拉
      cservicestatusdrow: [
        { text: "开启", value: true },
        { text: "关闭", value: false },
      ], // 客服状态下拉
      businessstatusdrow: [
        { text: "启用", value: 1 },
        { text: "禁用", value: 0 },
        { text: "审核中", value: 2 },
      ], // 商户状态下拉
      Lstatisticsdrow: [
        { text: "开启", value: true },
        { text: "关闭", value: false },
      ], // 登陆器访问统计下拉
      messagefunctiondrow: [
        { text: "开启", value: true },
        { text: "关闭", value: false },
      ], // 留言功能下拉
      dialogqq: {
        editflag: false,
        index: 0,
        show: false,
        name: "", // 客服名称
        qq: "", // QQ号码
      },
    };
  },
  methods: {
    // 获取商户的信息
    getinfo() {
      this.$api.merchant
        .merchantinfo({ merchantId: this.dataId })
        .then((data) => {
          if (data.status === 200) {
            this.basedata.id = data.data.id; // id
            this.basedata.username = data.data.nickname; // 用户名
            this.basedata.merchantAccount = data.data.account; // 商户账号
            this.basedata.joindate = data.data.joinDate; // 注册时间
            this.basedata.ratiogroup = data.data.rankId; // 比率组
            this.basedata.actingparentID = data.data.parentId; // 代理ID
            this.basedata.typemerchant = data.data.type; // 商户类型
            // this.basedata.websiteName = data.data.id; // 网站名
            // this.basedata.webdomainname = data.data.id; // 网站域名
            this.basedata.cSTelephone = data.data.servicePhone; // 客服电话
            this.basedata.businessQQ = data.data.qqNumber; // 商户ＱＱ
            this.basedata.cashcharge = data.data.fee; // 提现手续费
            this.basedata.customerQQ = JSON.parse(data.data.serviceQq); // 客服ＱＱ
            this.basedata.typesettlement = data.data.settlementType; // 结算类型
            this.basedata.pstatistics = data.data.isIps; // 发布站来源统计
            this.basedata.cservicestatus = data.data.serviceState; // 客服状态
            this.basedata.businessstatus = data.data.state; // 商户状态
            this.basedata.Lstatistics = data.data.isLogger; // 登陆器访问统计
            this.basedata.messagefunction = data.data.leaveState; // 留言功能
            this.basedata.contactComputer = data.data.phoneNumber; // 联系电话
            this.basedata.merchantmark = data.data.uuid; // 商户唯一标识
            this.basedata.merchantkey = data.data.secretKey; // 商户密钥
            this.basedata.wxserver = data.data.weixinInfos; // 微信服务
            this.basedata.isOpenRandomMoney = data.data.isOpenRandomMoney; // 是否开启随机金额
            this.basedata.idNumber = data.data.idNumber;
            this.basedata.realName = data.data.realName;
            this.basedata.isSigned = data.data.isSigned;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 比率组的下拉
    rankdrow() {
      this.$api.merchant
        .rankdrow()
        .then((data) => {
          if (data.status === 200) {
            this.ratiogroupdrow = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取银行信息
    getbankinfo() {
      this.$api.merchant
        .bankinfo({ merchantId: this.dataId })
        .then((data) => {
          if (data.status === 200) {
            this.bankinfo.tableData = [data.data];
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取用户产品信息
    getUserProducts() {
      this.$api.merchant
        .getUserProducts({ merchantId: this.dataId })
        .then((data) => {
          if (data.status === 200) {
            this.userProducts = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },

    // 获取银行下拉信息
    bankdrow() {
      this.$api.merchant
        .bankdrow()
        .then((data) => {
          if (data.status === 200) {
            this.bankinfo.bankdepositdrow = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 银行信息点击编辑
    editclick(item) {
      this.bankinfo.id = item.id;
      this.bankinfo.accountname = item.realName;
      this.bankinfo.bankdeposit = item.bankName;
      this.bankinfo.bankopeningbranch = item.bankBranch;
      this.bankinfo.accountnumber = item.bankNumber;
      this.bankinfo.idNumber = item.idNumber;
      this.bankinfo.show = true;
    },
    // 弹框的初始化
    dialoginit() {
      this.bankinfo.id = ""; // id号
      this.bankinfo.accountname = ""; // 账户名
      this.bankinfo.bankdeposit = ""; // 开户银行
      this.bankinfo.bankopeningbranch = ""; // 开户支行
      this.bankinfo.accountnumber = ""; // 账户卡号
      this.bankinfo.idNumber = '';
    },
    // 更新资金商户的信息
    bankupdate() {
      this.$api.merchant
        .bankupdate({
          id: this.bankinfo.id,
          realName: this.bankinfo.accountname,
          bankName: this.bankinfo.bankdeposit,
          bankBranch: this.bankinfo.bankopeningbranch,
          bankNumber: this.bankinfo.accountnumber,
          idNumber: this.bankinfo.idNumber
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("编辑成功！");
            this.bankinfo.show = false;
            this.getbankinfo();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },

    // 更新用户专属信息
    userProductUpdate() {
      this.$api.merchant
        .userProductUpdate({
          userId: this.basedata.id,
          products: this.userProducts
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("更新成功！");
            this.showUserProduct = false;

          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 重置密码
    resetpassword() {
      this.$messageError("此接口有变动");
      this.$api.merchant
        .passwordset({
          merchantId: this.dataId,
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("密码重置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    resetting() {
      this.$confirm("重置密码后,将恢复系统默认登陆密码,是否重置？")
        .then(() => {
          this.resetpassword();
        })
        .catch(() => { });
    },
    // 重置二级密码
    resetSecondPassword() {
      this.$api.merchant
        .resetPassword({
          merchantId: this.dataId,
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("二级密码重置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 重置二级密码提示
    resetTip() {
      this.$confirm("重置密码后,将恢复系统默认二级密码,是否重置？")
        .then(() => {
          this.resetSecondPassword();
        })
        .catch(() => { });
    },
    // 冻结解冻请求
    frozenbank(id, state) {
      this.$api.merchant
        .frozenbank({
          id: id,
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess(state ? "冻结成功！" : "解冻成功！");
            this.getbankinfo();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 冻结解冻商户行
    freeze(id, state) {
      this.$confirm(
        state ? "是否冻结该商户账户余额?" : "是否解冻该商户账户余额?"
      )
        .then(() => {
          this.frozenbank(id, state);
        })
        .catch(() => { });
    },
    // 解绑微信
    unbindFun() {
      this.$api.merchant
        .unbindWeixin({
          merchantId: this.basedata.id,
          weixinInfos: this.basedata.weixin.checkedCities.map((item) => {
            return item.id;
          }),
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("解绑成功！");
            this.getinfo();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 确定要解绑
    unbindWeixin() {
      this.$confirm("是否确认要解绑微信服务？")
        .then(() => {
          this.unbindFun();
        })
        .catch(() => { });
    },
    // 微信的解绑全选方法
    handleCheckAllChange(val) {
      this.basedata.weixin.checkedCities = val ? this.basedata.wxserver : [];
      this.basedata.weixin.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.basedata.weixin.checkAll =
        checkedCount === this.basedata.wxserver.length;
      this.basedata.weixin.isIndeterminate =
        checkedCount > 0 && checkedCount < this.basedata.wxserver.length;
    },
    // 返回上一级
    backpage() {
      this.$emit("backpage", false);
    },
    // 商户更新提交
    merchantupdate() {
      this.$api.merchant
        .updatemerchant({
          id: this.dataId,
          nickname: this.basedata.username, // 用户名
          account: this.basedata.merchantAccount, // 商户账号
          joinDate: this.basedata.joindate, // 注册时间
          rankId: this.basedata.ratiogroup, // 比率组
          parentId: parseInt(this.basedata.actingparentID), // 代理ID
          type: this.basedata.typemerchant, // 商户类型
          // this.basedata.websiteName = data.data.id; // 网站名
          // this.basedata.webdomainname = data.data.id; // 网站域名
          servicePhone: this.basedata.cSTelephone, // 客服电话
          qqNumber: this.basedata.businessQQ, // 商户ＱＱ
          fee: parseInt(this.basedata.cashcharge), // 提现手续费：
          serviceQq: JSON.stringify(this.basedata.customerQQ), // 客服ＱＱ
          settlementType: this.basedata.typesettlement, // 结算类型
          isIps: this.basedata.pstatistics, // 发布站来源统计
          serviceState: this.basedata.cservicestatus, // 客服状态
          state: this.basedata.businessstatus, // 商户状态
          isLogger: this.basedata.Lstatistics, // 登陆器访问统计
          leaveState: this.basedata.messagefunction, // 留言功能
          phoneNumber: this.basedata.contactComputer, // 联系电话
          uuid: this.basedata.merchantmark, // 商户唯一标识
          secretKey: this.basedata.merchantkey, // 商户密钥
          isOpenRandomMoney: this.basedata.isOpenRandomMoney, // 是否开启随机金额
          // this.basedata.wxserver = data.data.id; // 微信服务
          idNumber: this.basedata.idNumber,
          realName: this.basedata.realName,
          isSigned: this.basedata.isSigned
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("编辑成功！");
            this.$emit("backpage", true);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 新增客服QQ的弹框初始化
    dialogqqinit() {
      this.dialogqq.editflag = false;
      this.dialogqq.index = 0;
      this.dialogqq.name = "";
      this.dialogqq.qq = "";
    },
    // 新增客服QQ
    addserver() {
      if (this.dialogqq.name === "") {
        this.$messageError("请输入客服名称！");
        return;
      } else if (this.dialogqq.qq === "") {
        this.$messageError("请输入QQ号！");
        return;
      }
      this.basedata.customerQQ.push({
        name: this.dialogqq.name,
        qq: this.dialogqq.qq,
      });
      this.dialogqq.show = false;
    },
    // 编辑客服QQ
    editqq(data, index) {
      this.dialogqq.index = index;
      this.dialogqq.editflag = true;
      this.dialogqq.name = data.name;
      this.dialogqq.qq = data.qq;
      this.dialogqq.show = true;
    },
    // 编辑客服QQ提交
    editserver() {
      if (this.dialogqq.name === "") {
        this.$messageError("请输入客服名称！");
        return;
      } else if (this.dialogqq.qq === "") {
        this.$messageError("请输入QQ号！");
        return;
      }
      this.basedata.customerQQ.splice(this.dialogqq.index, 1, {
        name: this.dialogqq.name,
        qq: this.dialogqq.qq,
      });
      this.dialogqq.show = false;
    },
    // 删除客服qq
    delQQ(index) {
      this.basedata.customerQQ.splice(index, 1);
    },
  },
  created() {
    this.getinfo();
    this.rankdrow();
    this.getbankinfo();
    this.bankdrow();
    this.getUserProducts();
  },
};
</script>

<style lang="scss" scoped>
.gs_tablestyle {
  background: #fff;

  table {
    width: 100%;

    td {
      padding: 8px;
      border: 1px solid #e4eaec;

      &.tit {
        background: #f1f7f9;
        text-align: right;
      }
    }
  }
}

.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;

  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;

      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
        width: 70px;
        display: inline-block;
      }

      .txtbox {
        display: inline-block;
        width: 400px;
      }
    }
  }
}

.popitem {
  cursor: help;
}

.editserverBox {
  padding-left: 20px;

  .list {
    margin-bottom: 10px;

    .tit {
      float: left;
      width: 90px;
      height: 32px;
      line-height: 32px;
    }

    .content {
      float: left;
      width: 250px;
    }
  }
}
</style>
